module.exports = __webpack_public_path__ + "img/img_verified_idphoto_c.6dc623ae.png";